/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AdmissionType = "InPatient" | "Observation" | "OutPatient" | "%future added value";
export type BarrierStatus = "Open" | "Resolved" | "%future added value";
export type BedRequestStatus = "Anticipated" | "AnticipatedDischarge" | "AnticipatedUnitTransfer" | "Cancelled" | "CheckedIn" | "DischargeOrderWithDelay" | "Discharged" | "IntentToAdmit" | "Pending" | "PendingDischarge" | "PendingUnitTransfer" | "Ready" | "ReadyForDischarge" | "ReadyForUnitTransfer" | "Transferred" | "%future added value";
export type BedRequestType = "Admission" | "UnitTransfer" | "%future added value";
export type DepartmentType = "AdmissionSource" | "Unit" | "%future added value";
export type OwnerMessageStatus = "ACKNOWLEDGED" | "NEEDS_REASSIGNMENT" | "UNACKNOWLEDGED" | "%future added value";
export type ProgressionIndicator = "AtRisk" | "HighRisk" | "NotSet" | "OnTime" | "%future added value";
export type VisitStatus = "Admitted" | "Discharged" | "PreAdmission" | "%future added value";
export type KpiViewQueryVariables = {||};
export type KpiViewQueryResponse = {|
  +kpi: ?$ReadOnlyArray<?{|
    +name: string,
    +exchangeName: ?string,
    +capped: {|
      +workingOE: number,
      +mtdOE: number,
      +monthEndOE: number,
    |},
    +uncapped: {|
      +workingOE: number,
      +mtdOE: number,
      +monthEndOE: number,
    |},
  |}>,
  +viewer: {|
    +facilities: $ReadOnlyArray<{|
      +name: string,
      +exchangeName: string,
      +id: string,
      +departments: {|
        +nodes: ?$ReadOnlyArray<{|
          +id: string,
          +exchangeName: string,
          +name: string,
          +type: DepartmentType,
          +includedInLosCalculation: boolean,
          +beds: {|
            +totalCount: number,
            +edges: $ReadOnlyArray<{|
              +bed: {|
                +id: string,
                +name: string,
                +exchangeName: string,
                +status: string,
                +visit: ?{|
                  +id: string,
                  +visitNumber: ?string,
                  +homeBedExchangeName: ?string,
                  +admissionType: ?AdmissionType,
                  +admissionTime: ?any,
                  +patientProblem: ?string,
                  +admittingComplaint: ?string,
                  +bedRequestStatus: ?BedRequestStatus,
                  +bedRequests: $ReadOnlyArray<{|
                    +id: string,
                    +bedRequestType: BedRequestType,
                    +bedRequestStatus: BedRequestStatus,
                    +updatedWhen: any,
                    +bedExchangeName: ?string,
                  |}>,
                  +visitStatus: VisitStatus,
                  +anticipatedDischargeTime: ?any,
                  +anticipatedDischargeUpdatedBy: ?{|
                    +id: string,
                    +userName: string,
                    +firstName: string,
                    +lastName: string,
                  |},
                  +targetDischargeTime: ?any,
                  +decisionTime: ?any,
                  +tlos: ?number,
                  +currentDayOfStay: ?number,
                  +insurancePlans: $ReadOnlyArray<{|
                    +planName: string,
                    +priority: any,
                  |}>,
                  +meta: {|
                    +dischargeToday: boolean,
                    +tlosExceeded: boolean,
                    +plannedDischargeExceeded: boolean,
                    +decisionDue: boolean,
                    +timeElapsedSinceAdmission: any,
                  |},
                  +drgAttributes: ?{|
                    +code: string,
                    +title: string,
                    +level: string,
                    +targetLos: number,
                    +modifyTargetLos: boolean,
                  |},
                  +drgUpdatedBy: ?{|
                    +userName: string,
                    +firstName: string,
                    +lastName: string,
                  |},
                  +patient: {|
                    +id: string,
                    +mrn: ?string,
                    +age: ?string,
                    +gender: ?string,
                    +lastName: ?string,
                    +middleInitial: ?string,
                    +firstName: ?string,
                  |},
                  +workingDischargeDisposition: ?{|
                    +id: string,
                    +code: ?string,
                    +value: ?string,
                  |},
                  +dischargeVendor: ?string,
                  +attendingPhysician: ?{|
                    +id: string,
                    +firstName: ?string,
                    +lastName: ?string,
                    +primary: boolean,
                    +role: {|
                      +id: string,
                      +code: ?string,
                      +value: ?string,
                    |},
                  |},
                  +plan: ?{|
                    +id: string,
                    +progressionIndicator: ProgressionIndicator,
                    +appliedTemplates: ?$ReadOnlyArray<?{|
                      +name: string
                    |}>,
                    +meta: ?{|
                      +milestoneMeta: {|
                        +onTime: any,
                        +overdue: any,
                        +completed: any,
                      |},
                      +lengthOfStayMeta: {|
                        +forecast: ?any,
                        +cappedForecast: ?any,
                      |},
                      +actualOE: ?number,
                    |},
                    +milestones: $ReadOnlyArray<?{|
                      +id: string
                    |}>,
                    +barriers: $ReadOnlyArray<?{|
                      +id: string,
                      +name: string,
                      +description: string,
                      +status: BarrierStatus,
                      +pinned: boolean,
                      +auditMeta: ?{|
                        +created: any,
                        +createdBy: {|
                          +userName: string,
                          +firstName: string,
                          +lastName: string,
                        |},
                        +updated: any,
                        +updatedBy: {|
                          +userName: string,
                          +firstName: string,
                          +lastName: string,
                        |},
                      |},
                      +category: {|
                        +code: string,
                        +value: string,
                      |},
                      +escalation: ?{|
                        +auditMeta: ?{|
                          +created: any,
                          +createdBy: {|
                            +userName: string,
                            +firstName: string,
                            +lastName: string,
                          |},
                        |}
                      |},
                      +ownerMessageStatus: ?OwnerMessageStatus,
                      +ownerKnownUser: ?{|
                        +id: string,
                        +emailReceiver: boolean,
                        +instantMessageReceiver: boolean,
                      |},
                      +owner: ?string,
                      +ownerRole: ?{|
                        +code: ?string,
                        +value: ?string,
                      |},
                      +notes: ?$ReadOnlyArray<?{|
                        +id: string,
                        +text: string,
                        +auditMeta: ?{|
                          +created: any,
                          +createdBy: {|
                            +userName: string,
                            +firstName: string,
                            +lastName: string,
                          |},
                          +updated: any,
                          +updatedBy: {|
                            +userName: string,
                            +firstName: string,
                            +lastName: string,
                          |},
                        |},
                        +pinned: boolean,
                      |}>,
                    |}>,
                    +careTeamMembers: $ReadOnlyArray<?{|
                      +id: string,
                      +name: ?string,
                      +primary: ?boolean,
                      +role: {|
                        +id: string,
                        +code: ?string,
                        +value: ?string,
                      |},
                    |}>,
                  |},
                  +anticipatedTransferTime: ?any,
                  +anticipatedDischargeTimeAutoPopulated: ?boolean,
                  +anticipatedTransferTimeAutoPopulated: ?boolean,
                |},
              |}
            |}>,
          |},
        |}>
      |},
    |}>
  |},
|};
export type KpiViewQuery = {|
  variables: KpiViewQueryVariables,
  response: KpiViewQueryResponse,
|};
*/


/*
query KpiViewQuery {
  kpi {
    name
    exchangeName
    capped {
      workingOE
      mtdOE
      monthEndOE
    }
    uncapped {
      workingOE
      mtdOE
      monthEndOE
    }
    id
  }
  viewer {
    facilities {
      name
      exchangeName
      id
      departments(first: 10000) {
        nodes {
          id
          exchangeName
          name
          type
          includedInLosCalculation
          beds(first: 10000) {
            totalCount
            edges {
              bed: node {
                id
                name
                exchangeName
                status
                visit {
                  id
                  visitNumber
                  homeBedExchangeName
                  admissionType
                  admissionTime
                  patientProblem
                  admittingComplaint
                  bedRequestStatus
                  bedRequests {
                    id
                    bedRequestType
                    bedRequestStatus
                    updatedWhen
                    bedExchangeName
                  }
                  visitStatus
                  anticipatedDischargeTime
                  anticipatedDischargeUpdatedBy {
                    id
                    userName
                    firstName
                    lastName
                  }
                  targetDischargeTime
                  decisionTime
                  tlos
                  currentDayOfStay
                  insurancePlans {
                    planName
                    priority
                    id
                  }
                  meta {
                    dischargeToday
                    tlosExceeded
                    plannedDischargeExceeded
                    decisionDue
                    timeElapsedSinceAdmission
                    id
                  }
                  drgAttributes {
                    code
                    title
                    level
                    targetLos
                    modifyTargetLos
                    id
                  }
                  drgUpdatedBy {
                    userName
                    firstName
                    lastName
                    id
                  }
                  patient {
                    id
                    mrn
                    age
                    gender
                    lastName
                    middleInitial
                    firstName
                  }
                  workingDischargeDisposition {
                    id
                    code
                    value
                  }
                  dischargeVendor
                  attendingPhysician {
                    id
                    firstName
                    lastName
                    primary
                    role {
                      id
                      code
                      value
                    }
                  }
                  plan {
                    id
                    progressionIndicator
                    appliedTemplates {
                      name
                      id
                    }
                    meta {
                      milestoneMeta {
                        onTime
                        overdue
                        completed
                      }
                      lengthOfStayMeta {
                        forecast
                        cappedForecast
                      }
                      actualOE
                    }
                    milestones {
                      id
                    }
                    barriers {
                      id
                      name
                      description
                      status
                      pinned
                      auditMeta {
                        created
                        createdBy {
                          userName
                          firstName
                          lastName
                          id
                        }
                        updated
                        updatedBy {
                          userName
                          firstName
                          lastName
                          id
                        }
                      }
                      category {
                        code
                        value
                        id
                      }
                      escalation {
                        auditMeta {
                          created
                          createdBy {
                            userName
                            firstName
                            lastName
                            id
                          }
                        }
                        id
                      }
                      ownerMessageStatus
                      ownerKnownUser {
                        id
                        emailReceiver
                        instantMessageReceiver
                      }
                      owner
                      ownerRole {
                        code
                        value
                        id
                      }
                      notes {
                        id
                        text
                        auditMeta {
                          created
                          createdBy {
                            userName
                            firstName
                            lastName
                            id
                          }
                          updated
                          updatedBy {
                            userName
                            firstName
                            lastName
                            id
                          }
                        }
                        pinned
                      }
                    }
                    careTeamMembers {
                      id
                      name
                      primary
                      role {
                        id
                        code
                        value
                      }
                    }
                  }
                  anticipatedTransferTime
                  anticipatedDischargeTimeAutoPopulated
                  anticipatedTransferTimeAutoPopulated
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workingOE",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mtdOE",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "monthEndOE",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "KPIDetails",
  "kind": "LinkedField",
  "name": "capped",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "KPIDetails",
  "kind": "LinkedField",
  "name": "uncapped",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includedInLosCalculation",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitNumber",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "homeBedExchangeName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admissionType",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admissionTime",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientProblem",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admittingComplaint",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bedRequestStatus",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "BedRequest",
  "kind": "LinkedField",
  "name": "bedRequests",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bedRequestType",
      "storageKey": null
    },
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedWhen",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bedExchangeName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitStatus",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedDischargeTime",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "anticipatedDischargeUpdatedBy",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetDischargeTime",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTime",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tlos",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentDayOfStay",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeToday",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tlosExceeded",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedDischargeExceeded",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionDue",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeElapsedSinceAdmission",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "level",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetLos",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modifyTargetLos",
  "storageKey": null
},
v41 = [
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Patient",
  "kind": "LinkedField",
  "name": "patient",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mrn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "middleInitial",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v44 = [
  (v5/*: any*/),
  (v36/*: any*/),
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkingDischargeDispositionDTO",
  "kind": "LinkedField",
  "name": "workingDischargeDisposition",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeVendor",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primary",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "CodeTablePair",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "attendingPhysician",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressionIndicator",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "PlanMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MilestoneMeta",
      "kind": "LinkedField",
      "name": "milestoneMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overdue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LengthOfStayMeta",
      "kind": "LinkedField",
      "name": "lengthOfStayMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cappedForecast",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualOE",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Milestone",
  "kind": "LinkedField",
  "name": "milestones",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v56/*: any*/),
    (v57/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v41/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v59 = [
  (v36/*: any*/),
  (v43/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ownerMessageStatus",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "KnownUser",
  "kind": "LinkedField",
  "name": "ownerKnownUser",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailReceiver",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instantMessageReceiver",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "CareTeamMember",
  "kind": "LinkedField",
  "name": "careTeamMembers",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v0/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedTransferTime",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedDischargeTimeAutoPopulated",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedTransferTimeAutoPopulated",
  "storageKey": null
},
v68 = [
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v5/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v69/*: any*/),
    (v57/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v68/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = [
  (v36/*: any*/),
  (v43/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "KpiViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "KPI",
        "kind": "LinkedField",
        "name": "kpi",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facilities",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "DepartmentConnection",
                "kind": "LinkedField",
                "name": "departments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Department",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v1/*: any*/),
                      (v0/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "BedConnection",
                        "kind": "LinkedField",
                        "name": "beds",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BedEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "bed",
                                "args": null,
                                "concreteType": "Bed",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v0/*: any*/),
                                  (v1/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Visit",
                                    "kind": "LinkedField",
                                    "name": "visit",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "InsurancePlan",
                                        "kind": "LinkedField",
                                        "name": "insurancePlans",
                                        "plural": true,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v30/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "VisitMeta",
                                        "kind": "LinkedField",
                                        "name": "meta",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DrgAttributes",
                                        "kind": "LinkedField",
                                        "name": "drgAttributes",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v39/*: any*/),
                                          (v40/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AuditUser",
                                        "kind": "LinkedField",
                                        "name": "drgUpdatedBy",
                                        "plural": false,
                                        "selections": (v41/*: any*/),
                                        "storageKey": null
                                      },
                                      (v42/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v49/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Plan",
                                        "kind": "LinkedField",
                                        "name": "plan",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v50/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateInfo",
                                            "kind": "LinkedField",
                                            "name": "appliedTemplates",
                                            "plural": true,
                                            "selections": [
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v51/*: any*/),
                                          (v52/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Barrier",
                                            "kind": "LinkedField",
                                            "name": "barriers",
                                            "plural": true,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v0/*: any*/),
                                              (v53/*: any*/),
                                              (v10/*: any*/),
                                              (v54/*: any*/),
                                              (v58/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "BarrierCategory",
                                                "kind": "LinkedField",
                                                "name": "category",
                                                "plural": false,
                                                "selections": (v59/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Escalation",
                                                "kind": "LinkedField",
                                                "name": "escalation",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuditMeta",
                                                    "kind": "LinkedField",
                                                    "name": "auditMeta",
                                                    "plural": false,
                                                    "selections": [
                                                      (v55/*: any*/),
                                                      (v56/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v60/*: any*/),
                                              (v61/*: any*/),
                                              (v62/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CodeTablePair",
                                                "kind": "LinkedField",
                                                "name": "ownerRole",
                                                "plural": false,
                                                "selections": (v59/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "BarrierNote",
                                                "kind": "LinkedField",
                                                "name": "notes",
                                                "plural": true,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  (v63/*: any*/),
                                                  (v58/*: any*/),
                                                  (v54/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v64/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v65/*: any*/),
                                      (v66/*: any*/),
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "beds(first:10000)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "departments(first:10000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "KpiViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "KPI",
        "kind": "LinkedField",
        "name": "kpi",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facilities",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "DepartmentConnection",
                "kind": "LinkedField",
                "name": "departments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Department",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v1/*: any*/),
                      (v0/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "BedConnection",
                        "kind": "LinkedField",
                        "name": "beds",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BedEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "bed",
                                "args": null,
                                "concreteType": "Bed",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v0/*: any*/),
                                  (v1/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Visit",
                                    "kind": "LinkedField",
                                    "name": "visit",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "InsurancePlan",
                                        "kind": "LinkedField",
                                        "name": "insurancePlans",
                                        "plural": true,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v30/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "VisitMeta",
                                        "kind": "LinkedField",
                                        "name": "meta",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DrgAttributes",
                                        "kind": "LinkedField",
                                        "name": "drgAttributes",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v39/*: any*/),
                                          (v40/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AuditUser",
                                        "kind": "LinkedField",
                                        "name": "drgUpdatedBy",
                                        "plural": false,
                                        "selections": (v68/*: any*/),
                                        "storageKey": null
                                      },
                                      (v42/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v49/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Plan",
                                        "kind": "LinkedField",
                                        "name": "plan",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v50/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateInfo",
                                            "kind": "LinkedField",
                                            "name": "appliedTemplates",
                                            "plural": true,
                                            "selections": [
                                              (v0/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v51/*: any*/),
                                          (v52/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Barrier",
                                            "kind": "LinkedField",
                                            "name": "barriers",
                                            "plural": true,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v0/*: any*/),
                                              (v53/*: any*/),
                                              (v10/*: any*/),
                                              (v54/*: any*/),
                                              (v70/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "BarrierCategory",
                                                "kind": "LinkedField",
                                                "name": "category",
                                                "plural": false,
                                                "selections": (v71/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Escalation",
                                                "kind": "LinkedField",
                                                "name": "escalation",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuditMeta",
                                                    "kind": "LinkedField",
                                                    "name": "auditMeta",
                                                    "plural": false,
                                                    "selections": [
                                                      (v55/*: any*/),
                                                      (v69/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v60/*: any*/),
                                              (v61/*: any*/),
                                              (v62/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CodeTablePair",
                                                "kind": "LinkedField",
                                                "name": "ownerRole",
                                                "plural": false,
                                                "selections": (v71/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "BarrierNote",
                                                "kind": "LinkedField",
                                                "name": "notes",
                                                "plural": true,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  (v63/*: any*/),
                                                  (v70/*: any*/),
                                                  (v54/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v64/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v65/*: any*/),
                                      (v66/*: any*/),
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "beds(first:10000)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "departments(first:10000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0f9aaf6a081581bd712b93122a148c50",
    "id": null,
    "metadata": {},
    "name": "KpiViewQuery",
    "operationKind": "query",
    "text": "query KpiViewQuery {\n  kpi {\n    name\n    exchangeName\n    capped {\n      workingOE\n      mtdOE\n      monthEndOE\n    }\n    uncapped {\n      workingOE\n      mtdOE\n      monthEndOE\n    }\n    id\n  }\n  viewer {\n    facilities {\n      name\n      exchangeName\n      id\n      departments(first: 10000) {\n        nodes {\n          id\n          exchangeName\n          name\n          type\n          includedInLosCalculation\n          beds(first: 10000) {\n            totalCount\n            edges {\n              bed: node {\n                id\n                name\n                exchangeName\n                status\n                visit {\n                  id\n                  visitNumber\n                  homeBedExchangeName\n                  admissionType\n                  admissionTime\n                  patientProblem\n                  admittingComplaint\n                  bedRequestStatus\n                  bedRequests {\n                    id\n                    bedRequestType\n                    bedRequestStatus\n                    updatedWhen\n                    bedExchangeName\n                  }\n                  visitStatus\n                  anticipatedDischargeTime\n                  anticipatedDischargeUpdatedBy {\n                    id\n                    userName\n                    firstName\n                    lastName\n                  }\n                  targetDischargeTime\n                  decisionTime\n                  tlos\n                  currentDayOfStay\n                  insurancePlans {\n                    planName\n                    priority\n                    id\n                  }\n                  meta {\n                    dischargeToday\n                    tlosExceeded\n                    plannedDischargeExceeded\n                    decisionDue\n                    timeElapsedSinceAdmission\n                    id\n                  }\n                  drgAttributes {\n                    code\n                    title\n                    level\n                    targetLos\n                    modifyTargetLos\n                    id\n                  }\n                  drgUpdatedBy {\n                    userName\n                    firstName\n                    lastName\n                    id\n                  }\n                  patient {\n                    id\n                    mrn\n                    age\n                    gender\n                    lastName\n                    middleInitial\n                    firstName\n                  }\n                  workingDischargeDisposition {\n                    id\n                    code\n                    value\n                  }\n                  dischargeVendor\n                  attendingPhysician {\n                    id\n                    firstName\n                    lastName\n                    primary\n                    role {\n                      id\n                      code\n                      value\n                    }\n                  }\n                  plan {\n                    id\n                    progressionIndicator\n                    appliedTemplates {\n                      name\n                      id\n                    }\n                    meta {\n                      milestoneMeta {\n                        onTime\n                        overdue\n                        completed\n                      }\n                      lengthOfStayMeta {\n                        forecast\n                        cappedForecast\n                      }\n                      actualOE\n                    }\n                    milestones {\n                      id\n                    }\n                    barriers {\n                      id\n                      name\n                      description\n                      status\n                      pinned\n                      auditMeta {\n                        created\n                        createdBy {\n                          userName\n                          firstName\n                          lastName\n                          id\n                        }\n                        updated\n                        updatedBy {\n                          userName\n                          firstName\n                          lastName\n                          id\n                        }\n                      }\n                      category {\n                        code\n                        value\n                        id\n                      }\n                      escalation {\n                        auditMeta {\n                          created\n                          createdBy {\n                            userName\n                            firstName\n                            lastName\n                            id\n                          }\n                        }\n                        id\n                      }\n                      ownerMessageStatus\n                      ownerKnownUser {\n                        id\n                        emailReceiver\n                        instantMessageReceiver\n                      }\n                      owner\n                      ownerRole {\n                        code\n                        value\n                        id\n                      }\n                      notes {\n                        id\n                        text\n                        auditMeta {\n                          created\n                          createdBy {\n                            userName\n                            firstName\n                            lastName\n                            id\n                          }\n                          updated\n                          updatedBy {\n                            userName\n                            firstName\n                            lastName\n                            id\n                          }\n                        }\n                        pinned\n                      }\n                    }\n                    careTeamMembers {\n                      id\n                      name\n                      primary\n                      role {\n                        id\n                        code\n                        value\n                      }\n                    }\n                  }\n                  anticipatedTransferTime\n                  anticipatedDischargeTimeAutoPopulated\n                  anticipatedTransferTimeAutoPopulated\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ed8e868263beebc041900845046ea6b1';

module.exports = node;
